import React, { createContext, useContext, useState } from 'react';

const SessionContext = createContext();

const defaultAuditValues = {
  /** UserRoleProjectSiteMapping.nUserRoleProjectSiteMapping — set from session (recordedByMappingId) after login/CheckSession */
  nRecordedBy: 1,
  nRecordedAtTimeZone: 91,
  vRecordedAtOffset: '+05:30:00',
  vRecordedSign: 'System Admin (admin@ctms.com) (ADMIN)',
};

/**
 * Session Context Provider
 * Audit values in memory only (no localStorage). Server sets audit headers from session.
 */
export const SessionProvider = ({ children }) => {
  const [auditValues, setAuditValues] = useState(defaultAuditValues);

  const initializeAuditValues = (customValues = {}) => {
    setAuditValues({
      ...defaultAuditValues,
      ...customValues,
    });
  };

  const updateAuditValue = (key, value) => {
    setAuditValues(prev => ({
      ...prev,
      [key]: value,
    }));
  };

  const resetAuditValues = () => {
    setAuditValues(defaultAuditValues);
  };

  const clearAuditValues = () => {
    setAuditValues(defaultAuditValues);
  };

  const value = {
    auditValues,
    initializeAuditValues,
    updateAuditValue,
    resetAuditValues,
    clearAuditValues,
    nRecordedBy: auditValues.nRecordedBy,
    nRecordedAtTimeZone: auditValues.nRecordedAtTimeZone,
    vRecordedAtOffset: auditValues.vRecordedAtOffset,
    vRecordedSign: auditValues.vRecordedSign,
  };

  return (
    <SessionContext.Provider value={value}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within SessionProvider');
  }
  return context;
};

export default SessionContext;
